<template>
  <div>
    <button @click="openCreateFolderModal" class="btn p-3 flex items-center justify-center border-2 border-opacity-10 hover:border-opacity-20 text-yank hover:text-opacity-70 transition mr-5 shadow-sm">
        <SmallFolderIcon class="h-4 w-4"/>
        <span class="ml-2 hidden md:block">New Folder</span>
    </button>
    <div v-if="createFolderModalOpen" class="absolute flex justify-center items-center z-40 h-screen w-full">
        <CreateFolderModal class="absolute top-4 right-4 md:right-32 w-64" @closeModal="closeCreateFolderModal" @submit="createFolder"/>
    </div>
</div>
</template>

<script>
import CreateFolderModal from '@/components/my-media/CreateFolderModal.vue'
import SmallFolderIcon from '@/components/svg/SmallFolderIcon'

export default {
    name:"CreateFolder",
    
    components: { CreateFolderModal, SmallFolderIcon },

    data(){
        return{
            createFolderModalOpen: false,
        }
    },

    methods: {
        closeCreateFolderModal() {
            this.createFolderModalOpen = false;
        },
        openCreateFolderModal() {
            this.createFolderModalOpen = true;
        },
        createFolder(folderName) {
            this.$emit('submit', folderName)
        },
    },
}
</script>